import React, { useState, useEffect, useCallback, useContext } from "react";
import { OrganicationNavbar } from "../../reusedcomponent/navbar";
import CreateExpenditure from "./modal/create_expenditure";
import EditExpenditure from "./modal/edit_expenditure";
import { ApiService } from "../../../../../services/ApiService";
import { useAlert } from "react-alert";
import { ConfirmTemplate } from "../../../../../components/confirm";
import useModal from "../../../../../utils/useModal";
import Modal from "react-modal";
import moment from "moment";
import { AuthContext } from "../../../../../Context/AuthContext";
import { formattCurrency } from "../../../../../utils/formatCurrency";

import { PageBody } from "../../../../../components/loader";
import { useLoadingMessage } from "../../../../../components/useLoadingMessage";

import { orgarnizationMngtThunk } from "../../../../../store/actions/organizationmanagement/orgarnization.thunk";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "white",
    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const OrganizationRequesExpenditure = () => {
  const { user } = useContext(AuthContext);
  const alert = useAlert();
  const param = useParams();
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const [EditValue, setEditValue] = useState([]);
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("");
  const { modalIsOpen, openModal, closeModal } = useModal();
  const [searchExpenditure, setSearchExpenditure] = useState("");

  const { expenditures, requestType, requestCategory, request } = useSelector(
    (state) => state.orgarnizationMngt
  );

  console.log("tes", request);

  const openEditModal = () => {
    setOpen(true);
  };

  const closeEditModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();

  const deleteRequest = (id, request_type, description) => {
    const request = async () => {
      const request_id = {
        request_id: id,
        request_type: request_type,
        description: description,
      };
      const res = await ApiService.delete(`expenditures/${id}`);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getExpenditures();
      }
    };
    ConfirmTemplate(
      {
        title: "Delete Expenditure",
        message: "Are You Sure You Want To Delete This Expenditure",
      },
      request
    );
  };

  const getExpenditures = useCallback(async () => {
    updateLoader(true, "Getting expenditures");
    await dispatch(orgarnizationMngtThunk.getExpenditures(param.expenditureId));
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getExpenditures();
  }, []);

  console.log("EX", expenditures);

  const allExpenditures = expenditures.filter((exp) => {
    return (
      (exp &&
        exp.price
          .toString()
          .toLowerCase()
          .indexOf(searchExpenditure.toLowerCase()) !== -1) ||
      exp.description
        .toString()
        .toLowerCase()
        .indexOf(searchExpenditure.toLowerCase()) !== -1
    );
  });

  const prices = [];

  expenditures.map((exp) => prices.push(exp.price));
  const sunOfExpenditure = prices && prices.reduce((a, b) => a + b, 0);
  let balance = request.price - sunOfExpenditure;

  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <OrganicationNavbar />
        <Modal
          isOpen={open}
          onRequestClose={closeEditModal}
          style={customStyles}
          contentLabel="view user datails modal"
        >
          <EditExpenditure
            alert={alert}
            value={EditValue}
            closeModal={closeEditModal}
            getExpenditures={getExpenditures}
          />
        </Modal>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="view user datails modal"
        >
          <CreateExpenditure
            alert={alert}
            closeModal={closeModal}
            getExpenditures={getExpenditures}
            request_type={requestType}
            request_category={requestCategory}
            request_id={request.id}
          />
        </Modal>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <div className="card-title">
                      <div className="table-title">
                        <div className="row container-fluid">
                          <div className="col-sm-5">
                            <h2>
                              <b>
                                EXPENDITURE -{" "}
                                <small>
                                  {" "}
                                  {request.request_category &&
                                    request.request_category.name}
                                </small>
                              </b>
                            </h2>
                          </div>
                          <div className="col-sm-6">
                            {user.data.user.roles &&
                            user.data.user.roles.name !== "admin" ? (
                              <button
                                onClick={openModal}
                                className="btn nt-button-color-action"
                                data-toggle="modal"
                              >
                                <i className="material-icons">&#xE147; </i>{" "}
                                <span>CREATE EXPENDITURE</span>
                              </button>
                            ) : null}
                          </div>
                          <div className="col-md-1">
                            <Link
                              to="/dashboard/organization/request"
                              className="btn p-3"
                            >
                              <span class="fa fa-arrow-left"></span>
                              &nbsp;Back&nbsp;
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-2"></div>
                      <div className="col-md-8"></div>
                      <div className="form-group col-md-2">
                        <form class="form-inline my-2 my-lg-0 float-right">
                          <input
                            class="form-control mr-sm-2"
                            type="search"
                            placeholder="Search"
                            aria-label="Search"
                            name="search"
                            value={searchExpenditure}
                            onChange={(e) =>
                              setSearchExpenditure(e.target.value)
                            }
                          />
                        </form>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="card shadow m-2">
                          <div className="card-body">
                            <h5 className="text-dark">AMOUNT APPROVED </h5>
                            <h3 className="text-dark">
                              ₦ {formattCurrency(request.price)}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="card shadow m-2">
                          <div className="card-body">
                            <h5 className="text-dark">BALANCE REMAINING </h5>
                            <h3 className="text-dark">
                              ₦{" "}
                              {balance > 0
                                ? formattCurrency(balance)
                                : formattCurrency(0)}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="card shadow m-2">
                          <div className="card-body">
                            <h5 className="text-dark">OVER BUDGET </h5>
                            <h3 className="text-danger">
                              ₦{" "}
                              {balance < 0 &&
                                formattCurrency(Math.abs(balance))}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table
                        id="office_assets_view"
                        className="table table-bordered office-request-table"
                      >
                        {allExpenditures < 1 ? (
                          <div className="text-center m-auto">
                            <h1 className="text-dark">No record found</h1>
                          </div>
                        ) : (
                          <thead>
                            <tr>
                              <th>SN</th>
                              <th>Amount</th>
                              <th>Description</th>
                              <th>Date</th>
                              <th
                                style={{
                                  width: "40px",
                                }}
                                className="notexport"
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                        )}

                        <tbody>
                          {allExpenditures.map((expenditure, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>₦ {formattCurrency(expenditure.price)}</td>
                              <td>{expenditure.description}</td>
                              <td>
                                {moment(expenditure.expenditure_date).format(
                                  "ll"
                                )}
                              </td>
                              <td>
                                <div class="dropdown">
                                  <a
                                    href="#"
                                    class={`dropdown-toggle card-drop arrow-none ${
                                      user.data.user.roles &&
                                      user.data.user.roles.name === "admin" &&
                                      "disabled"
                                    } `}
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <h3 class="m-0 text-muted">
                                      <i class="fa fa-ellipsis-v"></i>
                                    </h3>
                                  </a>
                                  <div
                                    class="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="btnGroupDrop1"
                                  >
                                    <a
                                      class="dropdown-item"
                                      id=""
                                      onClick={() => {
                                        const value = {
                                          expenditure_id: expenditure.id,
                                          date: expenditure.expenditure_date,
                                          description: expenditure.description,
                                          price: expenditure.price,
                                        };
                                        setEditValue(value);
                                        openEditModal();
                                      }}
                                    >
                                      Edit
                                    </a>

                                    <a
                                      class="dropdown-item"
                                      id=""
                                      onClick={() => {
                                        deleteRequest(
                                          expenditure.id,
                                          expenditure.date,
                                          expenditure.price,
                                          expenditure.description
                                        );
                                      }}
                                    >
                                      Delete
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/organizationmanagement/request/expenditure/expenditure.js